import React, { useState } from 'react';
import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
import { useTrackingContext } from '../context/trackingContext';

const Input = ({
  label,
  type,
  className,
  questionIcon,
  placeholder,
  value,
  onChange,
  onBlur,
  name,
  error,
  errorClassName,
  tooltip,
  autoFocus,
  passwordVisiblity,
  disabled,
  readOnly
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { trackClick } = useTrackingContext();

  return (
    <>
      <div>
        {label && (
          <label htmlFor={label} className="block whitespace-nowrap mb-1">
            {label}
          </label>
        )}
        <div
          className={`flex flex-row h-[45px] pl-3 pr-3 py-3 z-1 border border-[#00000029]   ${
            disabled
              ? 'opacity-50 cursor-not-allowed'
              : ' opacity-100 focus:shadow-[0_3px_6px_#00000029] hover:shadow-[0_3px_6px_#00000029] focus-within:border-black hover:border-black'
          } focus-visible:outline-none focus-visible:border-black  placeholder:normal-case ${
            className ?? ''
          }`}>
          <input
            disabled={disabled}
            type={!showPassword ? type : 'text'}
            placeholder={placeholder}
            value={value}
            className={`w-full self-start focus-visible:outline-none placeholder:normal-case disabled:bg-transparent ${
              disabled && 'cursor-not-allowed'
            } ${readOnly ? 'cursor-not-allowed opacity-50' : ''}`}
            onChange={onChange}
            onBlur={onBlur}
            name={name}
            autoFocus={autoFocus}
            readOnly={readOnly}
          />
          {passwordVisiblity && (
            <div
              className="group flex self-end items-baseline justify-center cursor-pointer"
              onClick={() => {
                trackClick({ btnName: 'toggle password visiblity' });
                setShowPassword(!showPassword);
              }}>
              {!showPassword ? <IoIosEye /> : <IoIosEyeOff />}
            </div>
          )}
          {questionIcon && (
            <div className="group flex self-end items-baseline justify-center bg-black text-white w-[20px] h-[20px] cursor-pointer font-extrabold ml-2">
              <div className="flex relative">
                <div className="absolute z-10 invisible bg-black text-white -right-5 md:-right-10 top-[17px] group-hover:visible group-focus:visible w-[300px] border shadow-[0px_3px_6px_rgba(0,0,0,0.5)] p-2.5 rounded border-solid border-white">
                  {tooltip}
                </div>
              </div>
              ?
            </div>
          )}
        </div>
      </div>
      {error && <span className={`text-red text-sm ${errorClassName}`}>{error.message}</span>}
    </>
  );
};

export default Input;
